export const APPROVED = "approved";
export const DECLINED = "declined";
export const REVIEW = "review";
